// Form
import * as yup from "yup"

export const validationSchema = yup.object().shape({
  mr_product_status_code: yup.string().label("Status code").required(),
  mr_product_status_name: yup.string().label("Status name").required()
})